import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';

const SubscriptionRow = ({
  row,
  selectedSubscription,
  onSetSubscription,
  setSelectedSubscription,
  selectedClient,
  onSetClient,
  onSubscribe,
  onUnsubscribe,
}) => {
  const setupClient = () => {
    onSetClient(selectedClient);
    onSetSubscription(selectedSubscription);
  };

  const onChangeSwitch = () => {
    setupClient();
    if (selectedClient !== null && row.id === selectedSubscription) {
      if (row.subscribed) {
        onUnsubscribe();
      } else {
        onSubscribe('shared');
      }
    }
  };

  const onChangeSelect = event => {
    setupClient();
    if (selectedClient !== null && row.id === selectedSubscription) {
      onSubscribe(event.target.value);
    }
  };

  return (
    <TableRow
      hover
      key={row.id}
      onClick={() => setSelectedSubscription(row.id)}
      aria-checked={selectedSubscription === row.id}
      selected={selectedSubscription === row.id}
    >
      <TableCell component="th" scope="row">
        {row.name}
      </TableCell>
      <TableCell>{row.description}</TableCell>
      <TableCell>
        <Switch checked={row.subscribed} onChange={onChangeSwitch} />
      </TableCell>
      <TableCell>
        <Select
          disabled={row.subscribed !== true}
          name="tier"
          variant="outlined"
          value={row.subscribed !== true ? null : row.tier}
          onChange={event => onChangeSelect(event)}
        >
          <MenuItem value="trial">Trial</MenuItem>
          <MenuItem value="shared">Shared</MenuItem>
          <MenuItem value="dedicated">Dedicated</MenuItem>
        </Select>
      </TableCell>
    </TableRow>
  );
};

SubscriptionRow.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    subscribed: PropTypes.bool,
    tier: PropTypes.oneOf(['trial', 'shared', 'dedicated']),
  }).isRequired,
  selectedSubscription: PropTypes.shape({}).isRequired,
  onSetSubscription: PropTypes.func.isRequired,
  setSelectedSubscription: PropTypes.func.isRequired,
  selectedClient: PropTypes.shape({}).isRequired,
  onSetClient: PropTypes.func.isRequired,
  onSubscribe: PropTypes.func.isRequired,
  onUnsubscribe: PropTypes.func.isRequired,
};

export default SubscriptionRow;
